
import React from 'react';
import cx from 'classnames';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { Bubble } from '@home/components/TeaComponents';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';
import "@/pages/dashboard/assets/scss/page/RealtimeUsers/components/tableLine.scss";
import './index.scss';

export const getCountryImg = (iconCode: string) => {
  let img = '';
  try {
    img = getCountryFlag(iconCode);
  } catch (e) {
    img = getCountryFlag('default');
  }
  return img;
};

const MetricCardList = (props: any) => {
  const { className, style, list, showBubble, tooltipFormat } = props;

  return (
    <div className={cx(className)} style={style}>
      {
        list && list?.length > 0 &&
        <div className={`table-country-line-flex margin-t-10 ${showBubble ? 'dbb-show-bubble' : ''}`}>
          {
            list?.map((item: any, index: number) => (
              <Bubble
                key={item?.value}
                overlayClassName={`dbb-metric-card-bubble`}
                content={showBubble ? <FormatHtmlTextToReact text={tooltipFormat ? tooltipFormat?.(item) : item?.name} /> : ""}
              >
                <div className='table-line-country' key={index}>
                  <div className={`table-line-country-context dbd-realtime-user-count dbd-realtime-user-count-${index}`}>
                    {item?.iconCode && <img src={getCountryImg(item?.iconCode)} className='table-line-country-icon' />}
                    <div className='table-line-country-text'>{item?.name || ""}</div>
                  </div>
                  <div className='table-line-country-num'>{item?.value || ""}</div>
                </div>
              </Bubble>
            ))
          }
        </div>
      }
    </div>
  );
};

export default MetricCardList;